import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

// eslint-disable-next-line prefer-arrow-callback
const CardContent = forwardRef(function CardContent({
  children,
  disableGutters = false,
  gutters,
  className,
}, ref) {
  return (
    <div
      ref={ref}
      className={cx(
        'hms-card-content',
        disableGutters && 'hms-card-content__no-gutters',
        gutters && `hms-card-content__gutters-${gutters}`,
        className,
      )}
    >
      {children}
    </div>
  );
});

CardContent.propTypes = {
  children: T.node.isRequired,
  disableGutters: T.bool,
  // Default gutters size 16px
  // Supported sizes: 24
  // To add support more sizes, add appropriate styles to _hms-card.scss
  // Gutters format for two axis: '16-24'
  gutters: T.oneOfType([T.number, T.string]),
  className: T.string,
};

export default CardContent;
